import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/totalRevenueSalesSagas";
import GoogleChart from "../../../../components/charts/googleChart/googleChart";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";

const TableOrStackedBarChart = ({ currencySymbol }) => {
  const dispatch = useDispatch();

  const {
    data_table: { rows = [], cols = [] },
    options
  } = useSelector((state) => state.totalRevenueSales.chartData);

  const tableView = useSelector((state) => state.totalRevenueSales.selectedFilters.table_view);
  const updatesLoading = useSelector((state) => state.totalRevenueSales.updatesLoading);

  return updatesLoading ? (
    <LoadingAnimation text="Updating data..." />
  ) : (
    <GoogleChart
      chartName="sales_revenue_total_revenue_sales_chart"
      width="1350px"
      height={400}
      isTableView={tableView}
      rows={rows}
      columns={cols}
      options={options}
      position="top"
      enableEventListeners
      currencySymbol={currencySymbol}
      switchView={(data) => dispatch(actionCreators.updateTableView(data))}
    />
  );
};

export default TableOrStackedBarChart;
